/* eslint-disable no-lone-blocks */
import React, {useEffect, useState} from "react";
import {AuthenticationState, AzureAD} from "react-aad-msal";
import {configureAuthParams, getAuthProvider} from "../context/authProvider";
import ReactRecaptcha3 from "react-google-recaptcha3";
import {SITE_KEY} from "../utilities";
import {Navigate, useLocation, useNavigate} from "react-router-dom";
import {BRANDINGS_ICONS} from "../const/brandings";
import {Switch} from "antd";

export const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isEurope, setIsEurope] = useState(false);

  // Initialize auth provider lazily
  const authProvider = getAuthProvider();

  useEffect(() => {
    ReactRecaptcha3.init(SITE_KEY).then((status) => {
      /* eslint-disable-next-line no-console */
      console.log(status);
    });
  }, []);

  const handleLogin = () => {
    ReactRecaptcha3.getToken().then(
      (token) => {
        //console.log("token de recaptcha",token);
        // send request to backend
        validateRecapcha(token);
      },
      (error) => {
        /* eslint-disable-next-line no-console */
        console.log(error);
      }
    );
  };

  const validateRecapcha = (token) => {
    if (!isEurope) {
      console.info("LOGIN MEX")
      authProvider.login();
      return;
    }

    console.info("LOGIN EUR")
     const newAuthority = "https://login.microsoftonline.com/0fcc44cc-5868-4897-981e-7b04f79d61d8";
     const newClientId = "b3ecd430-b87f-4893-a91d-acd37a29117a";

    const updatedAuthProvider = configureAuthParams(newAuthority, newClientId);
     updatedAuthProvider.login();

    // const onFailure = (error) => {
    //   console.log("validateRecapcha error", error);
    // };
    // const onSuccess = ({ data }) => {
    //   console.log("respuesta de recaptcha", data);
    //   {
    //     data.statusCode === 200 ? RedirectToLogin() : alert(data.body);
    //   }
    // };
    // fetchRecapcha(token).then(onSuccess).catch(onFailure);
  };

  const handleRegionChange = (checked) => {
    setIsEurope(checked);
  };

  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, error, login }) => {
        const Unauthenticated = authenticationState === AuthenticationState.Unauthenticated;

        if (Unauthenticated) {
          return (
            <div className="App-body-login">
              <div className="login-content">
                <div className="login-form">
                  <img className="login-logo" src={BRANDINGS_ICONS.woeLogo} alt="WOE Logo" />

                  <p className="login-title">¡Te damos la bienvenida!</p>

                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                    <span style={{ marginRight: '10px', fontSize: '20px' }}>🇲🇽</span>
                    <Switch
                      checked={isEurope}
                      onChange={handleRegionChange}
                      style={{ backgroundColor: isEurope ? '#52c41a' : undefined }}
                    />
                    <span style={{ marginLeft: '10px', fontSize: '20px' }}>🇪🇺</span>
                  </div>

                  <button className="App-login-button" onClick={handleLogin}>
                    Ingresar
                  </button>

                  <a
                    className="avisoprivacidad"
                    href={`/Politicas_de_privacidad`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Aviso de privacidad
                  </a>
                </div>
              </div>

              <footer className="login-footer">
                <div className="footer-brands">
                  <img src={BRANDINGS_ICONS.allBrands} alt="Marcas" className="brands-logo" />
                </div>

                <div className="footer-separator" />

                <img src={BRANDINGS_ICONS.alseaLogo} alt="Alsea" className="alsea-logo" />
              </footer>
            </div>
          );
        }
        return <Navigate to="/Home" replace />;
      }}
    </AzureAD>
  );
};
